//Generated File 
export const GeneratedEditable = `GeneratedEditable`;
export const GeneratedFinal = `GeneratedFinal`;
export const NotGenerated = `NotGenerated`;
